import Swiper from "swiper";
import { A11y, Autoplay, EffectFade, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-testimonials").forEach((el) => {
    const container = el.querySelector(".swiper");
    const numSlides = el.querySelectorAll(".swiper-slide").length;
    const autoHeight = !!el.querySelector("[data-auto-height]");

    if (!container) {
      return;
    }

    new Swiper(container, {
      modules: [A11y, Autoplay, EffectFade, Navigation],
      speed: 750,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoHeight,
      loop: numSlides > 1,
      autoplay:
        numSlides > 1
          ? {
              delay: 5000,
              pauseOnMouseEnter: true,
              disableOnInteraction: false,
            }
          : false,
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
    });
  });
});
